'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger } from '@/components/ui/dropdown-menu';
function toLabel(value: string): string {
  const spaced = value.split('-').join(' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
export function PrV2SettingsRadioSubmenu(t0) {
  const $ = _c(13);
  const {
    label,
    value,
    options,
    onValueChange
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <DropdownMenuSubTrigger>{label}</DropdownMenuSubTrigger>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onValueChange) {
    t2 = nextValue => onValueChange(nextValue as T);
    $[2] = onValueChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== options) {
    t3 = options.map(_temp2);
    $[4] = options;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== value) {
    t4 = <DropdownMenuSubContent className="max-h-[65vh] w-64 overflow-y-auto"><DropdownMenuRadioGroup value={value} onValueChange={t2}>{t3}</DropdownMenuRadioGroup></DropdownMenuSubContent>;
    $[6] = t2;
    $[7] = t3;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <DropdownMenuSub>{t1}{t4}</DropdownMenuSub>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(option) {
  return <DropdownMenuRadioItem key={option} value={option} onSelect={_temp}>{toLabel(option)}</DropdownMenuRadioItem>;
}
function _temp(event) {
  return event.preventDefault();
}